import React, { useState } from "react";

const Keyboard = ({ onLetterClick, onBackspaceClick, onClearClick, onEnterClick, disabled }) => {
  const [pressedKey, setPressedKey] = useState(null);

  const handlePress = (key) => {
    setPressedKey(key);
    setTimeout(() => setPressedKey(null), 100);
  };

  const rows = [
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["Z", "X", "C", "V", "B", "N", "M"],
  ];

  const controlRow = ["ENTER", "CLEAR", "BACKSPACE"];

  const handleKeyPress = (key) => {
    if (disabled) return;
    handlePress(key);
    if (key === "ENTER") onEnterClick();
    else if (key === "BACKSPACE") onBackspaceClick();
    else if (key === "CLEAR") onClearClick();
    else onLetterClick(key);
  };

  const renderButton = (key) => {
    let displayLabel = key;
    if (key === "BACKSPACE") displayLabel = "⌫";

    const isControl = ["ENTER", "CLEAR", "BACKSPACE"].includes(key);
    const isPressed = pressedKey === key;

    return (
      <button
        key={key}
        style={{
          flex: "1",
          minWidth: 0,
          height: "clamp(48px, 11vw, 64px)",
          fontSize: isControl
            ? "clamp(0.55rem, 2vw, 0.75rem)"
            : "clamp(0.88rem, 3vw, 1.1rem)",
          fontWeight: isControl ? "700" : "820",
          backgroundColor: disabled
            ? "#e5e7eb"
            : isControl
            ? "#f3f4f6"
            : "#ffffff",
          color: disabled ? "#aaa" : isControl ? "#374151" : "#111",
          borderRadius: "8px",
          border: disabled
            ? "1px solid #d1d5db"
            : isControl
            ? "1.5px solid #d1d5db"
            : "1.5px solid #e5e7eb",
          cursor: disabled ? "default" : "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0",
          userSelect: "none",
          WebkitTapHighlightColor: "transparent",
          touchAction: "manipulation",
          transition: "background-color 50ms ease, box-shadow 50ms ease",
          opacity: disabled ? 0.48 : 1,
          boxShadow: isPressed && !disabled
            ? "inset 0 2px 8px rgba(0, 0, 0, 0.12)"
            : !disabled
            ? "0 1px 2px rgba(0, 0, 0, 0.05)"
            : "none",
        }}
        onPointerDown={(e) => {
          e.preventDefault();
          handleKeyPress(key);
        }}
        onClick={(e) => {
          if (e.detail === 0) handleKeyPress(key);
        }}
        disabled={disabled}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            transform: isPressed && !disabled ? "scale(0.92)" : "scale(1)",
            transition: "transform 50ms cubic-bezier(0.4, 0, 0.2, 1)",
            pointerEvents: "none",
          }}
        >
          {displayLabel}
        </span>
      </button>
    );
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "8px 8px 10px 8px",
        maxWidth: "100%",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "nowrap",
            gap: "4px",
            marginBottom: "4px",
          }}
        >
          {row.map((key) => renderButton(key))}
        </div>
      ))}

      {/* Control row */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "nowrap",
          gap: "4px",
          marginTop: "3px",
        }}
      >
        {controlRow.map((key) => renderButton(key))}
      </div>
    </div>
  );
};

export default Keyboard;
